import React__default, { Component } from 'react';
import { __extends } from '../../_virtual/_tslib.js';
import classnames from 'classnames';
import { MessageReceiptType } from '@deal/chat-firebase-client';
import styles from './styles.css.js';

var MessageStatus;

(function (MessageStatus) {
  MessageStatus[MessageStatus["Unknown"] = 0] = "Unknown";
  MessageStatus[MessageStatus["Pending"] = 1] = "Pending";
  MessageStatus[MessageStatus["Sent"] = 2] = "Sent";
  MessageStatus[MessageStatus["Delivered"] = 3] = "Delivered";
  MessageStatus[MessageStatus["Read"] = 4] = "Read";
})(MessageStatus || (MessageStatus = {}));

var MessageRow =
/** @class */
function (_super) {
  __extends(MessageRow, _super);

  function MessageRow(props) {
    var _this = _super.call(this, props) || this;

    _this.handleMessageStatusChange = _this.handleMessageStatusChange.bind(_this);
    _this.addMessageStatusListener = _this.addMessageStatusListener.bind(_this);
    _this.removeMessageStatusListener = _this.removeMessageStatusListener.bind(_this);
    return _this;
  }

  MessageRow.prototype.handleMessageStatusChange = function () {
    this.forceUpdate();
  };

  MessageRow.prototype.componentDidMount = function () {
    this.addMessageStatusListener(this.props.message);
  };

  MessageRow.prototype.componentWillReceiveProps = function (incomingProps) {
    if (incomingProps.message !== this.props.message) {
      this.removeMessageStatusListener(this.props.message);
      this.addMessageStatusListener(incomingProps.message);
    } // Also subscribe to changes to the next message (from "us"), since that status is
    //   used to determine whether to render this message's status (see `render`)


    if (incomingProps.nextMessageBySameParticipant !== this.props.nextMessageBySameParticipant) {
      if (this.props.nextMessageBySameParticipant) this.removeMessageStatusListener(this.props.nextMessageBySameParticipant);
      if (incomingProps.nextMessageBySameParticipant) this.addMessageStatusListener(incomingProps.nextMessageBySameParticipant);
    }
  };

  MessageRow.prototype.componentWillUnmount = function () {
    this.removeMessageStatusListener(this.props.message);
  };

  MessageRow.prototype.addMessageStatusListener = function (message) {
    message.on('read', this.handleMessageStatusChange, this);
    message.on('delivered', this.handleMessageStatusChange, this);
    message.on('sent', this.handleMessageStatusChange, this);
    message.on('initialized', this.handleMessageStatusChange, this);
  };

  MessageRow.prototype.removeMessageStatusListener = function (message) {
    message.off(undefined, this.handleMessageStatusChange, this);
  };

  MessageRow.prototype.getMessageStatus = function (message) {
    // Generate an array of ReceiptStates for this message, excluding the message sender
    var receiptStatuses = Object.keys(message.receipts).filter(function (key) {
      return key !== message.sentBy.userId;
    }).map(function (key) {
      return message.receipts[key];
    });

    if (receiptStatuses.some(function (status) {
      return status === MessageReceiptType.READ;
    })) {
      // The message has been read by at least one user
      return MessageStatus.Read;
    } else if (receiptStatuses.some(function (status) {
      return status === MessageReceiptType.DELIVERED;
    })) {
      // The message has been delivered to at least one user
      return MessageStatus.Delivered;
    } else if (receiptStatuses.some(function (status) {
      return status === MessageReceiptType.SENT;
    })) {
      // The message has been sent to at least one user
      return MessageStatus.Sent;
    } else if (message.pending) {
      // The message only exists locally
      return MessageStatus.Pending;
    } else {
      // This should not happen
      return MessageStatus.Unknown;
    }
  };

  MessageRow.prototype.renderStatus = function (status) {
    switch (status) {
      case MessageStatus.Pending:
        return 'Pending';

      case MessageStatus.Sent:
        return 'Sent';

      case MessageStatus.Delivered:
        return 'Delivered';

      case MessageStatus.Read:
        return 'Read';

      default:
        return null;
    }
  };

  MessageRow.prototype.render = function () {
    var _a;

    var message = this.props.message;
    var nextMessage = this.props.nextMessageBySameParticipant;
    var messageStatus = this.getMessageStatus(message);
    var nextMessageStatus = nextMessage && this.getMessageStatus(nextMessage);
    var isMyself = message.sentBy.isMyself; // Only render the message status if it's "our" message, AND:
    //   - The following message (sent by us) has a different status
    //   - OR, there is no following message

    var shouldRender = isMyself && (!nextMessage || messageStatus !== nextMessageStatus);
    /**
     * A row in a conversation that contains a single message.
     *
     * Sets the text-alignment to `right` or `left` depending on whether the message is coming from the message owner.
     */

    return React__default.createElement("div", {
      className: classnames(styles.row, styles.flat, (_a = {}, _a[styles.sent] = isMyself, _a))
    }, this.props.children, shouldRender && React__default.createElement("div", {
      className: styles.status
    }, this.renderStatus(messageStatus)));
  };

  return MessageRow;
}(Component);

export default MessageRow;
export { MessageStatus };
//# sourceMappingURL=index.js.map
